<ng-container *ngIf="kazaForm.get('types') && kazaForm.get('types')['controls']">
  <ng-container *ngFor="let control of kazaForm.get('types')['controls']; let i = index">
    <kz-field *ngIf="projectTypes[i]['@id'] == kazaTypeNoWork" absErrorMsg="true">
      <label kzLabel for="kz-choice-0{{i}}">{{projectTypes[i].name}}</label>
      <input kzCheckBox type="checkbox" id="kz-choice-0{{i}}" name="kz-choice-grid-0{{i}}"
             #projectTypeCheckbox
             [formControl]="control"
             (click)="changeProjectTypes(projectTypes[i], $event)"
      />
    </kz-field>
  </ng-container>
  <ul class="kz-choice-grid kaza-edit-types">
    <ng-container *ngFor="let control of kazaForm.get('types')['controls']; let i = index">
      <li class="kz-choice-grid-item"  *ngIf="projectTypes[i]['@id'] != kazaTypeNoWork">
        <div class="kz-field kz-field-project-type">
          <input kzCheckBox
                 class="kz-choice-grid-input" type="checkbox" [id]="'kz-choice-0' + i"
                 name="kz-choice-grid-0{{i}}"
                 #projectTypeCheckbox
                 [formControl]="control"
                 (click)="changeProjectTypes(projectTypes[i], $event)"
          />
          <label
            class="kz-choice-grid-label" for="kz-choice-0{{i}}"
            [ngClass]="{'kz-choice-selected': kazaForm.get('types')['controls'][i].value}">
            <span kzBadge badgeType="certified" title="team kozikaza" [empty]="true"></span>
            <span class="kz-choice-grid-img">
              <img *ngIf="projectTypes[i].media != null" [src]="getProjectTypeImg(projectTypes[i])" alt=""/>
            </span>
          </label>
          <label kzLabel for="kz-choice-0{{i}}">
            <span class="kz-project-type-label">{{projectTypes[i].name}}</span>
          </label>
        </div>
      </li>
    </ng-container>
  </ul>
  <div *ngIf="kazaForm.get('types').invalid && kazaForm.get('types').touched" kzError
       i18n="@@registration-create-kaza.missingProjectError">You must select a Kaza/project type (or no projects)</div>
</ng-container>
